<div class="hd-love">
  <header class="hd-love__header">
    <h3 class="hd-love__title">{{ vm().title }}</h3>
  </header>

  <!-- Algemene cheat-sheet-tekst: kop, intro, Ra-quote en vervolg -->
  @if (vm().paragraphs.length > 0 || vm().paragraphs2.length > 0) {
    <section class="hd-love__general">
      @if (vm().heading) {
        <h4 class="hd-love__general-heading">{{ vm().heading }}</h4>
      }
      @for (paragraph of vm().paragraphs; track $index) {
        <p class="hd-love__general-paragraph">{{ paragraph }}</p>
      }
      @if (vm().quote) {
        <p class="hd-love__quote">{{ vm().quote }} <span class="hd-love__quote-author">{{ vm().quoteAuthor }}</span></p>
      }
      @for (paragraph of vm().paragraphs2; track $index) {
        <p class="hd-love__general-paragraph">{{ paragraph }}</p>
      }
    </section>
  }

  <!-- De twee poortgroepen van het poster -->
  @for (group of vm().groups; track group.title) {
    <section class="hd-love__group">
      <h4 class="hd-love__group-title">
        <span class="hd-love__group-gates">{{ group.gates }}</span>
        {{ group.title }}
      </h4>
      @if (group.lead) {
        <p class="hd-love__group-lead">{{ group.lead }}</p>
      }
      @for (paragraph of group.paragraphs; track $index) {
        <p class="hd-love__general-paragraph">{{ paragraph }}</p>
      }
    </section>
  }

  <!-- Love-blokjes; klikken springt naar de detailsectie -->
  <div class="hd-love__hero">
    <div class="hd-love__cards">
      @for (gate of gates; track gate) {
        <button
          type="button"
          class="hd-love__card-button"
          [attr.data-hero-gate]="gate"
          [title]="vm().jumpHint"
          (click)="scrollToGate(gate)">
          <hd-circuit-gate-card scope="love" [gate]="gate" [rail]="railFor(gate)" size="compact" />
        </button>
      }
    </div>
  </div>

  <!-- Per poort de volledige liefdessectie -->
  <div class="hd-love__sections">
    @for (gate of gates; track gate) {
      <hd-circuit-gate-section class="hd-love__section" scope="love" [gate]="gate" [rail]="railFor(gate)" cardSize="compact" />
    }
  </div>

  <!-- Vragen ter reflectie -->
  @if (vm().reflectionQuestions.length > 0) {
    <section class="hd-love__reflection">
      <h4 class="hd-love__reflection-title">{{ vm().reflectionTitle }}</h4>
      <ul class="hd-love__reflection-list">
        @for (question of vm().reflectionQuestions; track $index) {
          <li class="hd-love__reflection-item">{{ question }}</li>
        }
      </ul>
    </section>
  }

  <!-- Ra-quotes van het poster -->
  @if (vm().quoteLeft || vm().quoteRight) {
    <section class="hd-love__closing-quotes">
      @if (vm().quoteLeft) {
        <p class="hd-love__quote">{{ vm().quoteLeft }}</p>
      }
      @if (vm().quoteRight) {
        <p class="hd-love__quote">{{ vm().quoteRight }}</p>
      }
    </section>
  }
</div>
